import { render, staticRenderFns } from "./OrderPaymentFailed.vue?vue&type=template&id=0be5030b&scoped=true"
import script from "./OrderPaymentFailed.vue?vue&type=script&lang=js"
export * from "./OrderPaymentFailed.vue?vue&type=script&lang=js"
import style0 from "./OrderPaymentFailed.vue?vue&type=style&index=0&id=0be5030b&prod&lang=scss"
import style1 from "./OrderPaymentFailed.vue?vue&type=style&index=1&id=0be5030b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be5030b",
  null
  
)

export default component.exports